'use strict'
const math = require('mathjs')

class Calculator {

    constructor(formula) {
        this.originalFormula = formula

    }

    execute(vars) {
        let result = 0
        try {
            result = math.eval(this.originalFormula, vars)
        } catch (e) {
            result = '###'
        }
        return String(result)
    }

}

export default Calculator


// WEBPACK FOOTER //
// ./src/common/Calculator.js